var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',[_vm._v(_vm._s(_vm._f("dateShort")(_vm.interval.startDate)))]),(_vm.span)?_c('span',[_vm._v(" - ")]):_vm._e(),(_vm.span)?_c('span',[_vm._v(_vm._s(_vm._f("dateShort")(_vm.interval.endDate)))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }